import CircleImage from "../../../../../components/Image/CircleImage";

const SelectCollaborator = ({ options, handleServiceChange, index, selectedCollaborator, collaborator }) => {
  return (
    <>
      <div
        key={collaborator._id}
        onClick={(e) => {
          handleServiceChange({ target: { name: "professional", value: collaborator._id } }, index);
          handleServiceChange({ target: { name: "hour", value: "" } }, index);
        }}
        className={`d-flex flex-column m-2 text-center c-pointer ${
          collaborator._id === selectedCollaborator ? "active " : ""
        }`}
      >
        <CircleImage className="ms-2 my-2" url={collaborator.avatar} />
        <span className="">{collaborator.name}</span>
      </div>
    </>
  );
};

export default SelectCollaborator;
